import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';
import createAccordion from '../../cmscomponents/accordion/accordion';

const DeliveryAccordion = ({ content }) => {
  const accordionRef = useRef(null);
  useEffect(() => {
    createAccordion(accordionRef.current).init();
  }, []);
  return createPortal(
    <dl className={`accordion-container ${content ? '' : 'display-none'}`} ref={accordionRef}>
      <dt className="accordion-header">
        <button type="button" className="accordion-trigger js-tracking-accordion" data-tracking-name="product delivery">
          <FormattedMessage id="products.pdp.description.delivery.title" />
          <i className="fa-regular fa-chevron-down" />
        </button>
      </dt>
      <dd className="accordion-panel">
        <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
      </dd>
    </dl>,
    document.getElementById('product-details-delivery')
  );
};

DeliveryAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default DeliveryAccordion;
